import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, IndexRoute } from 'react-router';
import { Provider } from 'react-redux';

import App from './components/App';
import Question from './components/Question';
import HomeScreen from './components/HomeScreen';
import EndScreen from './components/EndScreen';
import NotFound from './components/NotFound';

// import store
import store, { history } from './store';

import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import css from './styles/q360.css';
import animations from './styles/animations.css';
import { SnackbarProvider } from 'notistack';

import { createTheme, MuiThemeProvider } from '@material-ui/core';
import StyledSnackbarProvider from './components/StyledSnackbarProvider';

const app = document.getElementById('app');

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider theme={createTheme()}>
      <StyledSnackbarProvider>
        <Router history={history}>
          <Route path='/:hash' component={App}>
            <IndexRoute component={HomeScreen} />
            <Route path='/q/:eval/:page' component={Question} />
            <Route path='/:user/end' component={EndScreen} />
            <Route path='*' component={NotFound} />
          </Route>
        </Router>
      </StyledSnackbarProvider>
    </MuiThemeProvider>
  </Provider>,
  app,
);
